import { action, makeObservable, observable } from 'mobx';
import { TargetGroup } from '../models';

export class TargetGroupStore {
  @observable targetGroups: TargetGroup[] = [];

  constructor() {
    makeObservable(this);
  }

  @action
  setTargetGroups(targetGroups: TargetGroup[]) {
    this.targetGroups = targetGroups;
  }
}
